export default "__VITE_ASSET__CO$gSglI__"